import CoreIconsChangelogs from "../../../../../core-icons/CHANGELOG.md";
import * as React from 'react';
export default {
  CoreIconsChangelogs,
  React
};